'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'industry-windows';
var width = 512;
var height = 512;
var aliases = [127981,"industry-alt"];
var unicode = 'f3b3';
var svgPathData = 'M16 32l-16 0 0 448 512 0 0-377.4-22.9 11-153.1 73.5 0-84.9-23.2 11.6-152.8 76.4 0-158.1-144 0zM32 256l0-192 96 0 0 177.9 23.2-11.6 152.8-76.4 0 84 22.9-11 153.1-73.5 0 294.6-448 0 0-192zm64 48l-16 0 0 96 96 0 0-96-80 0zm16 64l0-32 32 0 0 32-32 0zm96-64l0 96 96 0 0-96-96 0zm32 32l32 0 0 32-32 0 0-32zm112-32l-16 0 0 96 96 0 0-96-80 0zm16 64l0-32 32 0 0 32-32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIndustryWindows = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;